<template>
  <div class="bg">
    <div class="content">
      <div class="btn">
        <el-button type="info" @click="quitBtn" size="mini"> 取消 </el-button>
        <el-button type="primary" size="mini"> 提交 </el-button>
      </div>
      <el-form
        ref="unitForm"
        :model="unitForm"
        :rules="rules"
        label-width="auto"
        label-position="left"
        status-icon
        :inline-message="true"
      >
        <el-card>
          <el-tag class="el-icon-warning-outline" size="mini"> 基本信息 </el-tag>
          <el-form-item label="参建企业：" prop="data1">
            <el-input
              v-model="unitForm.data1"
              placeholder="请输入参建单位"
              size="mini"
              clearable
            />
          </el-form-item>
          <el-form-item label="企业资质：">
            <el-input
              v-model="unitForm.data2"
              placeholder="请输入企业资质"
              size="mini"
              clearable
            />
          </el-form-item>
        </el-card>
        <el-card>
          <el-tag class="el-icon-warning-outline" size="mini">
            对接地市或住建部平台
          </el-tag>
          <el-form-item label="企业类型：">
            <el-tag v-if="unitType == '请选择企业类型'" size="mini" type="primary">
              <span @click="showunitTypePopup = true">{{ unitType }}</span>
            </el-tag>
            <span v-else @click="showunitTypePopup = true">{{ unitType }}</span>
            <van-popup
              v-model="showunitTypePopup"
              round
              position="bottom"
              :style="{
                height: 45,
              }"
            >
              <van-picker
                title="请选择企业类型"
                show-toolbar
                :columns="unitTypeOptions"
                @confirm="onConfirmunitType"
                @cancel="showunitTypePopup = false"
              />
            </van-popup>
          </el-form-item>
          <el-form-item label="银行名称：">
            <el-tag v-if="bankName == '请选择银行名称'" size="mini" type="primary">
              <span @click="showBankNamePopup = true">{{ bankName }}</span>
            </el-tag>
            <span v-else @click="showBankNamePopup = true">{{ bankName }}</span>
            <van-popup
              v-model="showBankNamePopup"
              round
              position="bottom"
              :style="{
                height: 45,
              }"
            >
              <van-picker
                title="请选择银行名称"
                show-toolbar
                :columns="bankNameOptions"
                @confirm="onConfirmBankName"
                @cancel="showBankNamePopup = false"
              />
            </van-popup>
          </el-form-item>
          <el-form-item label="银行卡号：">
            <el-input
              v-model="unitForm.data3"
              placeholder="请输入银行卡号"
              size="mini"
              clearable
            />
          </el-form-item>
          <el-form-item label="银行联号：">
            <el-input
              v-model="unitForm.data4"
              placeholder="请输入银行联号"
              size="mini"
              clearable
            />
          </el-form-item>
        </el-card>
        <el-card>
          <el-tag class="el-icon-warning-outline" size="mini"> 其他信息 </el-tag>
          <el-form-item label="进场时间：">
            <el-tag v-if="enterTime == '请选择具体进场时间'" size="mini" type="primary">
              <span @click="showEnterTimePopup = true">{{ enterTime }}</span>
            </el-tag>
            <span v-else @click="showEnterTimePopup = true">{{ enterTime }}</span>
            <van-popup
              v-model="showEnterTimePopup"
              round
              readonly="readonly"
              position="bottom"
              :style="{
                height: 45,
              }"
            >
              <van-datetime-picker
                v-model="currentDate"
                type="datetime"
                title="请选择具体入场时间"
                :min-date="minDate"
                :max-date="maxDate"
                :overlay="true"
                @confirm="confirmEnterTimeBtn"
                @cancel="showEnterTimePopup = false"
              />
            </van-popup>
          </el-form-item>
          <el-form-item label="退场时间：">
            <el-tag v-if="exitTime == '请选择具体退场时间'" size="mini" type="primary">
              <span @click="showExitTimePopup = true">{{ exitTime }}</span>
            </el-tag>
            <span v-else @click="showExitTimePopup = true">{{ exitTime }}</span>
            <van-popup
              v-model="showExitTimePopup"
              round
              readonly="readonly"
              position="bottom"
              :style="{
                height: 45,
              }"
            >
              <van-datetime-picker
                v-model="currentDate"
                type="datetime"
                title="请选择具体退场时间"
                :min-date="minDate"
                :max-date="maxDate"
                :overlay="true"
                @confirm="confirmExitTimeBtn"
                @cancel="showExitTimePopup = false"
              />
            </van-popup>
          </el-form-item>
          <el-form-item label="项目经理：" prop="data5">
            <el-input
              v-model="unitForm.data5"
              placeholder="请输入项目经理姓名"
              size="mini"
              clearable
            />
          </el-form-item>
          <el-form-item label="证件类型：">
            <el-tag v-if="certificate == '请选择证件类型'" size="mini" type="primary">
              <span @click="showCertificatePopup = true">{{ certificate }}</span>
            </el-tag>
            <span v-else @click="showCertificatePopup = true">{{ certificate }}</span>
            <van-popup
              v-model="showCertificatePopup"
              round
              position="bottom"
              :style="{
                height: 45,
              }"
            >
              <van-picker
                title="请选择证件类型"
                show-toolbar
                :columns="certificateOptions"
                @confirm="onConfirmCertificate"
                @cancel="showCertificatePopup = false"
              />
            </van-popup>
          </el-form-item>
          <el-form-item label="证件号码：" prop="data6">
            <el-input
              v-model="unitForm.data6"
              placeholder="请输入项目经理证件号码"
              size="mini"
              clearable
            />
          </el-form-item>
          <el-form-item label="联系电话：" prop="data7">
            <el-input
              v-model="unitForm.data7"
              placeholder="请输入项目经理联系电话"
              size="mini"
              clearable
            />
          </el-form-item>
          <el-form-item label="联系人：" prop="data8">
            <el-input
              v-model="unitForm.data8"
              placeholder="请输入联系人姓名"
              size="mini"
              clearable
            />
          </el-form-item>
          <el-form-item label="联系电话：" prop="data9">
            <el-input
              v-model="unitForm.data9"
              placeholder="请输入联系人电话"
              size="mini"
              clearable
            />
          </el-form-item>
        </el-card>
      </el-form>
    </div>
  </div>
</template>
<script>
import formRules from "@/utils/formRules.js";
export default {
  data() {
    return {
      // 企业类型
      showunitTypePopup: false,
      unitType: "请选择企业类型",
      unitTypeOptions: [
        "专业分包",
        "设备分包",
        "材料分包",
        "后勤服务",
        "特殊设备",
        "劳务分包",
        "监理",
        "建设单位",
        "总承包单位",
        "勘察",
        "设计单位",
        "其他",
      ],
      // 银行名称
      showBankNamePopup: false,
      bankName: "请选择银行名称",
      bankNameOptions: ["1", "2", "3"],
      unitForm: {
        data1: "",
        data2: "",
        data3: "",
        data4: "",
        data5: "",
        data6: "",
        data7: "",
        data8: "",
        data9: "",
      },

      // 具体进场时间
      showEnterTimePopup: false,
      enterTime: "请选择具体进场时间",
      // 具体退场时间
      showExitTimePopup: false,
      exitTime: "请选择具体退场时间",
      // 证件类型
      showCertificatePopup: false,
      certificate: "请选择证件类型",
      certificateOptions: ["身份证", "暂住证"],
      minDate: new Date(new Date().getFullYear() - 2, 1, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      // 表单验证
      rules: {
        data1: [{ validator: formRules.validateCn, trigger: "blur" }],
        data5: [{ validator: formRules.validateCn, trigger: "blur" }],
        data6: [{ validator: formRules.validateId, trigger: "blur" }],
        data7: [{ validator: formRules.validatePhone, trigger: "blur" }],
        data8: [{ validator: formRules.validateCn, trigger: "blur" }],
        data9: [{ validator: formRules.validatePhone, trigger: "blur" }],
      },
    };
  },
  methods: {
    //   选择企业类型
    onConfirmunitType(value) {
      this.unitType = value;
      this.showunitTypePopup = false;
    },
    // 选择银行名称
    onConfirmBankName(value) {
      this.bankName = value;
      this.showBankNamePopup = false;
    },

    // 选择具体入场时间
    confirmEnterTimeBtn(value) {
      this.enterTime = this.datePick.datePick(value);
      this.showEnterTimePopup = false;
    },
    // 选择具体退场时间
    confirmExitTimeBtn(value) {
      this.exitTime = this.datePick.datePick(value);
      this.showExitTimePopup = false;
    },
    // 选择证件类型
    onConfirmCertificate(value) {
      this.certificate = value;
      this.showCertificatePopup = false;
    },
    //取消按钮
    quitBtn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.bg {
  margin-bottom: 50px;
  min-height: 100vh;
  background-color: #f0f0f0;
}
.content {
  padding: 10px;
  .btn {
    text-align: right;
    margin-bottom: 10px;
  }
  /deep/.el-card {
    margin-bottom: 10px;
    .el-form-item {
      margin-bottom: 0px;
      // span:nth-child(1) {
      //   color: #c0c4cc;
      // }
    }
    .el-form-item__label {
      padding: 0;
    }
    .el-input__inner {
      border: unset;
      padding: 0;
    }
  }
}
</style>
